import { IoClose } from 'react-icons/io5';
import { Modal, ModalBody, ModalContent, ModalHeader } from '@ds';
import { RouteSchema, RouteSchemaType } from '@lp/features/RoutePlanner/components/RouteSchema';

export type ViewRouteSchemaModalProps = {
  title: string;
  route: RouteSchemaType;
  isOpen: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onClose: () => void;
};

export const ViewRouteSchemaModal = ({ title, route, isOpen, size = '4xl', onClose }: ViewRouteSchemaModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} style={{ top: 15 }} />}
      classNames={{
        base: 'px-6',
        body: 'px-0 pb-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {() => (
          <>
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>
              <RouteSchema {...route} />
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
